// Shared "Access" checkbox pair (Generation / Contract Management) used by
// both the create-user and edit-user forms in OrgUsersTab. Admin role locks
// both areas on (disabled + effective-true, computed by the caller); the
// areasEmpty error surfaces when a non-admin unchecks both.
import { clsx } from 'clsx';

interface AccessAreasFieldsetProps {
  isAdmin: boolean;
  generateAccess: boolean;
  manageAccess: boolean;
  onGenerateAccessChange: (checked: boolean) => void;
  onManageAccessChange: (checked: boolean) => void;
  areasEmpty: boolean;
}

export default function AccessAreasFieldset({
  isAdmin,
  generateAccess,
  manageAccess,
  onGenerateAccessChange,
  onManageAccessChange,
  areasEmpty,
}: AccessAreasFieldsetProps) {
  return (
    <div>
      <label className="label">Access</label>
      <div className="flex items-center gap-3 py-1">
        <label className={clsx(
          'flex items-center gap-2',
          isAdmin ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
        )}>
          <input
            type="checkbox"
            aria-label="Generation"
            checked={generateAccess}
            disabled={isAdmin}
            onChange={(e) => onGenerateAccessChange(e.target.checked)}
            className="h-4 w-4 rounded border-slate-300 text-brand-600 focus:ring-brand-500"
          />
          <span className="text-body-sm text-slate-700 dark:text-slate-300">Generation</span>
        </label>
        <label className={clsx(
          'flex items-center gap-2',
          isAdmin ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
        )}>
          <input
            type="checkbox"
            aria-label="Contract Management"
            checked={manageAccess}
            disabled={isAdmin}
            onChange={(e) => onManageAccessChange(e.target.checked)}
            className="h-4 w-4 rounded border-slate-300 text-brand-600 focus:ring-brand-500"
          />
          <span className="text-body-sm text-slate-700 dark:text-slate-300">Contract Management</span>
        </label>
      </div>
      {isAdmin && (
        <p className="text-caption text-slate-400 dark:text-slate-500 mt-1">
          Admin users have full access to all areas.
        </p>
      )}
      {areasEmpty && (
        <p className="text-caption text-red-600 dark:text-red-400 mt-1" role="alert">
          Select at least one access area.
        </p>
      )}
    </div>
  );
}
